import React from 'react';
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from '../utils/animationVariants';

import BackgroundSlider from '../components/BackgroundSlider';
import InfoSection from '../components/InfoSection';
import ProductSection from '../components/ProductSection';

function Home() {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <BackgroundSlider />
      <InfoSection />
      <ProductSection />
    </motion.div>
  );
}

export default Home;
